import { Head, useForm } from '@inertiajs/react';
import GuestLayout from '@/Layouts/GuestLayout';
import FormInput from '@/Components/FormInput';
import Alert from '@/Components/Alert';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

export default function ForgotPassword({ status }) {
    const { data, setData, post, processing, errors } = useForm({ email: '' });
    const submit = (e) => { e.preventDefault(); post('/forgot-password'); };

    return (
        <GuestLayout>
            <Head title="Forgot Password" />
            <div className="text-center mb-6">
                <h2 className="text-lg font-bold text-slate-800">Reset Password</h2>
                <p className="text-slate-400 text-xs mt-1">We'll send you a reset link</p>
            </div>
            {status && <Alert type="success" className="mb-4">{status}</Alert>}
            <form onSubmit={submit} className="space-y-4">
                <FormInput label="Email" type="email" icon={EnvelopeIcon} value={data.email} onChange={e => setData('email', e.target.value)} error={errors.email} required />
                <button type="submit" disabled={processing} className="w-full py-2.5 bg-emerald-700 hover:bg-emerald-800 text-white text-sm font-semibold rounded-xl transition-all shadow-sm disabled:opacity-50">
                    Send Reset Link
                </button>
            </form>
        </GuestLayout>
    );
}
